export const UserRoles = {
  faculty: "Faculty",
  branchEDP: "Branch EDP",
  academicHead: "Academic Head",
  academicCounsellor: "Academic Counsellor",
  regionalHead: "Regional Head",
  nationalHead: "National Head",
  NADTeam: "NAD Team",
  Developer: "Developer",
};
